module.exports = __webpack_public_path__ + "img/admin-hover.682cf22a.svg";